import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {WorkUpdateServiceService} from "../work-update-service.service";
import {ActivatedRoute, Router} from "@angular/router";
import {CentreService} from "../../../../../services/centre.service";
import {Observable, Subject} from "rxjs";
import {Centre, CentreOption} from "../../../../../interfaces/Centres";
import {EmployeeService} from "../../../../../services/employee.service";
import {map, tap, takeUntil} from "rxjs/operators";
import {LogService} from "../../../../../services/log.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MAT_DIALOG_DATA, MatDialog} from "@angular/material/dialog";
export interface WorkUpdate {
  id?: string;
  date: any;
  centreCode: string;
  centreName: string;
  submittedBy: string;
  task: string;
  remarks: string;
  createdAt: any;
}

@Component({
  selector: 'app-add-edit-work-update',
  templateUrl: './add-edit-work-update.component.html',
  styleUrls: ['./add-edit-work-update.component.scss']
})
export class AddEditWorkUpdateComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  teacherTypes = ['Teaching Team', 'Lead Teacher','Sr Teacher'];
  workForm!: FormGroup;
  centres$!: Observable<CentreOption[]>;

  filteredTeachers$!: Observable<any[]>;
  teachers$: Observable<any[]>
  isLoading : boolean = false;
  selectedCentre:any;
  displayCentre = (c: any) => c?.centreName;
  currentEditId:any;
  constructor(
    private fb: FormBuilder,
    private service: WorkUpdateServiceService,
    private route: ActivatedRoute,
    private router: Router,
    private mCentreService: CentreService,
    private mLogService : LogService,
    private mEmployeeService: EmployeeService,
    private snackBar: MatSnackBar,
    private dialogRef: MatDialog,
    @Inject(MAT_DIALOG_DATA) public id: string | null,
  ) {
    this.centres$ = this.mCentreService.getAllCentres();
    this.teachers$ = this.mEmployeeService.getTeachers();
    this.teachers$.pipe(takeUntil(this._destroyed$)).subscribe((res :any)=>{
      console.log(res)
    })
  }

  ngOnInit(): void {

    this.currentEditId = this.id;
    this.workForm = this.fb.group({
      date: [new Date(), Validators.required],
      teacherType: ['', Validators.required],
      centre:[[],Validators.required],
      submittedBy: [''],
      task: ['', Validators.required],
      remarks: ['']
    });

    // default load teachers
    this.filteredTeachers$ = this.teachers$;
    this.centres$ = this.mCentreService.getAllCentres().pipe(
      map((centres) => [
        { centreCode: 'HeadOffice', centreName: 'Head Office' },
        ...centres,
      ])
    );
    if (this?.id) {
      this.service.getWorkUpdateById(this.id).pipe(takeUntil(this._destroyed$)).subscribe((data: any) => {
        this.onTeacherSelection({ value: data?.teacherType });
        this.workForm.patchValue({
          date: data?.date.toDate(),
          teacherType: data?.teacherType,
          centre: data?.centre,
          submittedBy: data?.submittedBy,
          task: data?.task,
          remarks: data?.remarks
        });
        this.selectedCentre = data.centre || [];
      });
    }
  }

  onTeacherSelection(type: any) {
    if (!type.value) {
      this.filteredTeachers$ = this.teachers$;
      return;
    }

    if (type.value === 'Lead Teacher') {
      this.filteredTeachers$ = this.teachers$.pipe(
        tap(teachers => console.log('All teachers:', teachers)),
        map((teachers: any[]) => teachers.filter(t => t.role === 'Sr Teacher')),
        tap(filtered => console.log('Filtered (Lead Teacher → Sr Teacher):', filtered))
      );

    } else {
      this.filteredTeachers$ = this.teachers$.pipe(
        tap(teachers => console.log('All teachers:', teachers)),
        map((teachers: any[]) => teachers.filter(t => t.role === 'Teacher')),
        tap(filtered => console.log('Filtered (Teaching Team → Teacher):', filtered))
      );
    }
  }
  submit() {
    if (this.workForm.invalid) return;

    this.isLoading = true;

    const loggedInUser = JSON.parse(localStorage.getItem('userData') || '{}');
    const submittedBy = loggedInUser?.userName || 'Unknown User';

    const formValue = {
      ...this.workForm.value,
      submittedBy,        // auto inserted
      createdAt: new Date()
    };

    const request = this.id
      ? this.service.updateWorkUpdate(this.id, formValue)
      : this.service.addWorkUpdate(formValue);

    request
      .then(() => {
        const activity = {
          date: new Date().getTime(),
          section: 'Work Updates',
          action: this.id ? 'Update' : 'Submit',
          description: `Work Update ${this.id ? 'updated' : 'added'} by ${submittedBy}`,
          currentIp: localStorage.getItem('currentip')!
        };

        this.mLogService.addLog(activity);
        this.isLoading = false;

        this.snackBar.open(
          `Work Update ${this.id ? 'updated' : 'added'} successfully!`,
          'Close',
          { duration: 3000, verticalPosition: 'top', panelClass: ['snackbar-success'] }
        );

        this.dialogRef.closeAll();
      })
      .catch(() => {
        this.isLoading = false;
        this.snackBar.open(
          'Failed to save Work Update.',
          'Close',
          { duration: 3000, verticalPosition: 'top', panelClass: ['snackbar-error'] }
        );
      });
  }

  onCentreSelect(selectedCentres: any[]) {
    console.log(selectedCentres);
    const centreArray = selectedCentres.map(c => ({
      centreName: c.centreName,
      centreCode: c.centreCode
    }));
    this.selectedCentre = centreArray;
    this.workForm.patchValue({
      centre: centreArray   // ✔ save clean array of objects
    });
  }

  onCancel(){
    this.dialogRef.closeAll();
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
